/** Available FRM entity types */
export enum FrmEntityTypeEnum {
  /** Project ("Project" module) */
  PROJECT_PROJECT = 'project/project',
  /** Project template ("Project" module) */
  PROJECT_TEMPLATE = 'project/template',
  /** Project status ("Project" module) */
  PROJECT_STATUS = 'project/status',
  /** BRS task ("Finance" -> "BRS" module) */
  FINANCE_BRS_TASK = 'finance/brs/task',
  /** Planned income ("Finance" -> "BRS" module) */
  FINANCE_BRS_PLANNED_INCOME = 'finance/brs/planned-income',
  /** BRS task template ("Finance" -> "BRS" module) */
  FINANCE_BRS_TASK_TEMPLATE = 'finance/brs/task-template',
  /** BRS task status ("Finance" -> "BRS" module) */
  FINANCE_BRS_TASK_STATUS = 'finance/brs/task-status',
  /** BRS task priority ("Finance" -> "BRS" module) */
  FINANCE_BRS_TASK_PRIORITY = 'finance/brs/task-priority',
  /** Payment scenario ("Finance" -> "BRS" module) */
  FINANCE_BRS_PAYMENT_SCENARIO = 'finance/brs/payment-scenario',
  /** Budget request ("Finance" -> "Plan/Fact" module) */
  FINANCE_PLAN_FACT_BUDGET_REQUEST = 'finance/plan-fact/budget-request',
  /** Planning scenario ("Finance" -> "Plan/Fact" module) */
  FINANCE_PLAN_FACT_PLANNING_SCENARIO = 'finance/plan-fact/planning-scenario',
  /** Balance report format / structure ("Finance" -> "Plan/Fact" module) */
  FINANCE_PLAN_FACT_BALANCE_REPORT_FORMAT = 'finance/plan-fact/balance-report-format',
  /** Operator ("FDO" module) */
  FDO_OPERATOR = 'fdo/operator',
  /** Cash register equipment ("FDO" module) */
  FDO_KKT = 'fdo/kkt',
  /** Receipt ("FDO" module) */
  FDO_RECEIPT = 'fdo/receipt',
  /** Activity ("FDO" module) */
  FDO_ACTIVITY = 'fdo/activity',
  /** Document ("Finance" -> "Document" module) */
  FINANCE_DOCUMENT_DOCUMENT = 'finance/document/document',
  /** Bill ("Finance" -> "Document" module) */
  FINANCE_DOCUMENT_BILL = 'finance/document/bill',
  /** Bank statement parsing rule ("Finance" -> "Document" module) */
  FINANCE_DOCUMENT_BANK_STATEMENT_RULE = 'finance/document/bank-statement-rule',
  /** Salary distribution ("Finance" -> "Document" module) */
  FINANCE_DOCUMENT_SALARY_DISTRIBUTION = 'finance/document/salary-distribution',
  /** Mailing ("Debts" module) */
  DEBTS_MAILING = 'debts/mailing',
  /** Mailing template ("Debts" module) */
  DEBTS_MAILING_TEMPLATE = 'debts/mailing-template',
  /** Credit/Debit exclusion ("Debts" module) */
  DEBTS_CREDIT_DEBIT_EXCLUSION = 'debts/credit-debit-exclusion',
  /** Debt collection task */
  DEBTS_DEBT_COLLECTION_TASK = 'debts/debt-collection-task',
  /** Debt collection task */
  DEBTS_DEBT_COLLECTION_TASK_EVENT = 'debts/debt-collection-task-event',
  /** Deal ("Finance" -> "Business" module) */
  FINANCE_BUSINESS_DEAL = 'finance/business/deal',
  /** Deals group ("Finance" -> "Business" module) */
  FINANCE_BUSINESS_DEALS_GROUP = 'finance/business/deals-group',
  /** Deal status ("Finance" -> "Business" module) */
  FINANCE_BUSINESS_DEAL_STATUS = 'finance/business/deal-status',
  /** Deal type ("Finance" -> "Business" module) */
  FINANCE_BUSINESS_DEAL_TYPE = 'finance/business/deal-type',
  /** Client ("Basis" -> "Client" module) */
  BASIS_CLIENT_CLIENT = 'basis/client/client',
  /** Company ("Basis" -> "Client" module) */
  BASIS_CLIENT_COMPANY = 'basis/client/company',
  /** Counterparty ("Basis" -> "Client" module) */
  BASIS_CLIENT_CONTRAGENT = 'basis/client/contragent',
  /** Bank details ("Basis" -> "Client" module) */
  BASIS_CLIENT_BANK_DETAILS = 'basis/client/bank-details',
  /** 1C ERP database connection ("Basis" -> "Integration" module) */
  INTEGRATION_CONNECTION_1C = 'basis/integration/connection-1c',
  /** Contract ("Finance" -> "Document" module) */
  FINANCE_DOCUMENT_CONTRACT = 'finance/document-contract',
  /** External user ("Basis" -> "Security" module) */
  BASIS_SECURITY_EXTERNAL_USER = 'basis/security/external-user',
  /** User ("Basis" -> "Security" module) */
  BASIS_SECURITY_USER = 'basis/security/user',
  /** User group ("Basis" -> "Security" module) */
  BASIS_SECURITY_USER_GROUP = 'basis/security/user-group',
  /** Role ("Basis" -> "Security" module) */
  BASIS_SECURITY_ROLE = 'basis/security/role',
  /** User group ("Basis" -> "Security" module) */
  BASIS_SECURITY_WORK_SCHEDULE = 'basis/security/work-schedule',
  /** Vat rate */
  BASIS_CATALOG_NDS = 'basis/catalog/nds',
  /** Direction ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_DIRECTION = 'basis/catalog/direction',
  /** Unit ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_UNIT = 'basis/catalog/unit',
  /** Filial ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_FILIAL = 'basis/catalog/filial',
  /** Room ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_ROOM = 'basis/catalog/room',
  /** Document type ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_DOCUMENT_TYPE = 'basis/catalog/document-type',
  /** Document file template ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_DOCUMENT_FILE_TEMPLATE = 'basis/catalog/document-file-template',
  /** Operation type ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_OPERATION_TYPE = 'basis/catalog/operation-type',
  /** 1C ERP native operation type ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_ERP_1C_OPERATION_TYPE = 'basis/catalog/erp-1c-operation-type',
  /** Master milestone ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_MASTER_MILESTONE = 'basis/catalog/master-milestone',
  /** Approval scheme ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_APPROVAL_SCHEME = 'basis/catalog/approval-scheme',
  /** Nomenclature item ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_NOMENCLATURE_ITEM = 'basis/catalog/nomenclature-item',
  /** Nomenclature group ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_NOMENCLATURE_GROUP = 'basis/catalog/nomenclature-group',
  /** Cost center ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_COST_CENTER = 'basis/catalog/cost-center',
  /** Cost center ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_ACCOUNTING_ACCOUNT = 'basis/catalog/accounting-account',
  /** Currency ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_CURRENCY = 'basis/catalog/currency',
  /** Budget classification code (KBK) ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_BUDGET_CLASSIFICATION_CODE = 'basis/catalog/budget-classification-code',
  /** Payer status (tax payments) ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_PAYER_STATUS = 'basis/catalog/payer-status',
  /** Account dimension setting ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_ACCOUNT_DIMENSION_SETTING = 'basis/catalog/account-dimension-setting',
  /** Cash/flow item ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_CASH_FLOW_ITEM = 'basis/catalog/cash-flow-item',
  /** Other financial flow ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_COST_ITEM = 'basis/catalog/cost-item',
  /** Other financial flow */
  BASIS_CATALOG_OTHER_FINANCIAL_FLOW = 'basis/catalog/other-financial-flow',
  /** Warehouse ("Basis" -> "Catalog" module) */
  BASIS_CATALOG_WAREHOUSE = 'basis/catalog/warehouse',
  /** Task ("Helpdesk" module) */
  HELPDESK_TASK = 'helpdesk/task',
  /** Task status ("Helpdesk" module) */
  HELPDESK_TASK_STATUS = 'helpdesk/task-status',
  /** Task type ("Helpdesk" module) */
  HELPDESK_TASK_TYPE = 'helpdesk/task-type',
  /** Task template ("Helpdesk" module) */
  HELPDESK_TASK_TEMPLATE = 'helpdesk/task-template',
  /** EAV entity ("Helpdesk" module) */
  HELPDESK_EAV_ENTITY = 'helpdesk/eav-entity',
  /** Converter ("PACS" module) */
  PACS_CONVERTER = 'pacs/converter',
  /** NetPing device ("PACS" module) */
  PACS_NET_PING_DEVICE = 'pacs/net-ping-device',
  /** Access card ("PACS" module) */
  PACS_ACCESS_CARD = 'pacs/access-card',
  /** Passage order ("PACS" module) */
  PACS_PASSAGE_ORDER = 'pacs/passage-order',
  /** Passage order employee ("PACS" module) */
  PACS_PASSAGE_ORDER_EMPLOYEE = 'pacs/passage-order-employee',
  /** Transit task ("CCTV" module) */
  CCTV_TRANSIT_TASK = 'cctv/transit-task',
  /** Resident car ("CCTV" module) */
  CCTV_RESIDENT_CAR = 'cctv/resident-car',
  /** Car category ("CCTV" module) */
  CCTV_CAR_CATEGORY = 'cctv/car-category',
  /** Hikvision camera ("CCTV" module) */
  CCTV_HIKVISION_CAMERA = 'cctv/hikvision-camera',
  /** File ("Storage" module) */
  STORAGE_FILE = 'storage/file',
  /** EAV entity type ("Basis" -> "EAV" module) */
  BASIS_EAV_ENTITY_TYPE = 'basis/eav/entity-type',
}
